import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CanActivateUsuario } from './can-activate-usuario';
import { UsuarioComponent } from './usuario.component';
import { UsuarioFormComponent } from './form';

@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: '',
                canActivateChild: [CanActivateUsuario],
                children: [
                    {path: '', component: UsuarioComponent},
                    {path: 'novo', component: UsuarioFormComponent},
                    {path: ':id', component: UsuarioFormComponent}
                ]
            }
        ])
    ],
    exports: [
        RouterModule
    ],
    providers: [
        CanActivateUsuario
    ]
})
export class UsuarioRoutingModule { }
